module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProMedium.2087191.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProMedium.woff
// module id = Q5rX
// module chunks = 1